import { OrdersDataViewContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";

import React, { FC, useContext } from "react";
import { connect } from "react-redux";

export interface RMAHistoryResultCountStyles {
    orderCountText?: TypographyPresentationProps;
}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        pagination: state.KGPState.RMAStore.RMACollection?.pagination,
    };
};

export const resultCountStyles: RMAHistoryResultCountStyles = {};

const styles = resultCountStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const RMAHistoryResultCount: FC<Props> = ({ pagination }) => {
    if (!pagination) {
        return null;
    }

    const { totalItemCount } = pagination;

    if (totalItemCount === 0) {
        return null;
    }

    return (
        <Typography {...styles.orderCountText} data-test-selector="rmaHistory_resultCount">
            {totalItemCount} {translate("RMA Orders")}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RMAHistoryResultCount),
    definition: {
        group: "Common",
        displayName: "RMA Result Count",
    },
};

export default widgetModule;
